import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { MusicIcon, CloseIcon } from '../../../../model/icons';

// Аудио-слот: подпись + плитка загрузки (мгновенно) ИЛИ превью с очисткой.
export default function AudioSlot({ caption, url, disabled, onUpload, onClear }) {
    const inputRef = useRef(null);

    return (
        <div>
            <div className="media-cap">{caption}</div>
            {url ? (
                <div className="media-have">
                    <audio controls src={url} />
                    {!disabled && onClear && (
                        <button type="button" className="clr" onClick={onClear} aria-label="Удалить"><CloseIcon /></button>
                    )}
                </div>
            ) : disabled ? (
                <div className="media-tile" style={{ cursor: 'default', opacity: .55 }}>
                    <MusicIcon /><span className="ml">—</span>
                </div>
            ) : (
                <label className="media-tile">
                    <MusicIcon /><span className="ml">Загрузить</span>
                    <input
                        ref={inputRef}
                        type="file"
                        accept="audio/*"
                        style={{ display: 'none' }}
                        onChange={(e) => { const f = e.target.files?.[0]; if (f) onUpload(f); e.target.value = ''; }}
                    />
                </label>
            )}
        </div>
    );
}

AudioSlot.propTypes = {
    caption: PropTypes.string.isRequired,
    url: PropTypes.string,
    disabled: PropTypes.bool,
    onUpload: PropTypes.func.isRequired,
    onClear: PropTypes.func
};

AudioSlot.defaultProps = { url: null, disabled: false, onClear: null };
